<div class="absolute top-0 left-0 w-full h-full bg-black-alpha-50 z-4" *ngIf="api.blocked" (click)="buttonClose.click()" pStyleClass="#slideover-cart" leaveToClass="hidden" leaveActiveClass="fadeoutright"></div>

<div id="slideover-cart" class="z-5 hidden surface-overlay absolute top-0 right-0 shadow-2 w-full md:w-30rem h-full">
	<div class="flex flex-column h-full">
		<div class="surface-100 p-3 flex">
			<button #buttonClose (click)="api.bodyOverflow('auto')" pButton pRipple icon="pi pi-chevron-right" class="p-button-text p-button-rounded" pStyleClass="#slideover-cart" leaveToClass="hidden" leaveActiveClass="fadeoutright"></button>
			<div class="border-right-1 border-300 mx-3"></div>
			<span class="text-900 text-xl font-medium inline-flex align-items-center ml-1">Mon panier</span>
			<button *ngIf="api.order.prods.length > 0" (click)="api.clearCart()" pButton pRipple icon="pi pi-trash" label="Vider mon panier" class="p-button-danger p-button-outlined ml-4"></button>
		</div>
		<div class="flex-auto overflow-y-auto overflow-x-hidden py-3 px-3">
			<ul class="list-none p-0 m-0" *ngIf="api.order && api.order.prods">
				<ng-container *ngFor="let prod of api.order.prods | orderBy: 'id'">
					<li class="flex align-items-center mb-4 fadeinright" [ngClass]="{'fadeoutright' : prod.quantity === 0}" *ngIf="prod.quantity > 0">
						<div class="relative">
							<div class="w-6rem h-6rem flex-shrink-0 border-round" >
								<img [src]="'https://cdn.blackrockgames.fr/items/'+prod.Id+'/couverture.png?width=120'" class="w-full h-full" />
							</div>
							<div style="top:-0.5rem" class="absolute right-0 left-0 flex align-items-center bg-green-200 text-green-600 text-sm px-2 py-1 border-round" *ngIf="prod.offerName">
								<div>
									{{prod.offerName}}
								</div>
							</div>
						</div>
						<div class="flex-auto pl-3">
							<div class="flex align-items-center justify-content-between mb-3">
								<span class="text-sm text-900 font-medium pr-3">{{prod.name_item}}</span>
								<div class="text-900 font-bold">
									<!-- <div class="text-200 line-through white-space-nowrap">
										{{prod.priceHT * prod.quantity | currency:'EUR'}} <span class="text-xs">HT</span>
									</div> -->
									<p-tag [value]="'-'+prod.discountRate+'%'" severity="success"></p-tag>
									<div class="white-space-nowrap">{{(prod.priceHT - prod.discountAmount) * prod.quantity  | currency:'EUR'}} <span class="text-xs">HT</span></div>
								</div>
							</div>
							<!-- <div class="text-600 text-sm mb-3">Blue | Medium</div> -->
							<div class="flex flex-auto justify-content-between align-items-center">
								<p-inputNumber [step]="prod.step" [disabled]="prod.gift || prod.offerId" (onInput)="prod.quantity = $event.value;api.changeQty(prod)" (onBlur)="api.roundToStep(prod)" [showButtons]="true" buttonLayout="horizontal" spinnerMode="horizontal" [min]="0" inputStyleClass="w-3rem text-center py-1 px-1 border-transparent" [(ngModel)]="prod.quantity" 
								class="border-1 surface-border border-round" decrementButtonClass="p-button-text py-1 px-1" incrementButtonClass="p-button-text py-1 px-1" incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus"></p-inputNumber>
								<button *ngIf="!prod.gift || prod.ItemType == '1' " (click)="prod.quantity = 0;api.changeQty(prod)" pButton pRipple icon="pi pi-trash" class="p-button-danger p-button-text p-button-rounded"></button>
								<!-- <button (click)="prod.quantity = prod.giftQty;api.totalOrder()" pButton icon="pi pi-plus" class="p-button-success p-button-text p-button-outlined" *ngIf="prod.gift && prod.offerName && prod.discountRate != 100 && prod.quantity === 0"></button>
								<button (click)="prod.quantity = 0;api.totalOrder()" pButton icon="pi pi-trash" class="p-button-danger p-button-text" *ngIf="prod.gift && prod.offerName && prod.discountRate != 100 && prod.quantity > 0"></button> -->
							</div>
						</div>
					</li>
				</ng-container>
			</ul>
		</div>
		<div class="border-top-1 surface-border p-3 pt-2">
			<div class="flex align-items-center justify-content-between mb-2">
				<span class="text-900 font-medium">Total <span class="text-600 text-sm">HT</span></span>
				<span class="text-900 font-bold">{{api.order.sumHT | currency:'EUR'}}</span>
			</div>
			<div class="flex align-items-center justify-content-between mb-2">
				<span class="text-900 font-medium">TVA</span>
				<span class="text-900 font-bold">{{(api.order.sumTTC - api.order.sumHT) | currency:'EUR'}}</span>
			</div>
			<div class="flex align-items-center justify-content-between mb-2">
				<span class="text-900 font-medium">Frais de port</span>
				<span class="text-900 font-bold">{{(api.order.shipping) | currency:'EUR'}}</span>
			</div>
			<div class="flex align-items-center justify-content-between mb-3">
				<span class="text-900 font-medium">Total <span class="text-600 text-sm">TTC</span></span>
				<span class="text-900 font-bold">{{api.order.sumTTC + api.order.shipping | currency:'EUR'}}</span>
			</div>
			<button (click)="buttonClose.click()" [disabled]="api.order.prods.length === 0 || api.order.prods == []" pButton pRipple class="p-button-success mb-3 w-full" label="Voir ma commande" [routerLink]="['/commande']"></button>
			<button (click)="buttonClose.click()" pButton pRipple class="p-button-outlined p-button-secondary w-full" label="Poursuivre ma commande"></button>
		</div>
	</div>
</div>

<p-dialog header="{{api.selectedProduct ? api.selectedProduct.name_item : ''}}" [(visible)]="api.dialogOffers" [modal]="true" (onShow)="offerChoosed = undefined; api.selectedProduct.quantity = api.selectedProduct.step ? api.selectedProduct.step : 1;" [dismissableMask]="true" contentStyleClass="p-0">
	<div class="surface-ground px-4 pb-4" *ngIf="api.selectedProduct">
		<div class="text-4xl py-4">Saisissez une quantité</div>
		<div class="surface-card shadow-2 border-round p-2">
			<p-inputNumber [step]="api.selectedProduct.step" (onBlur)="api.roundToStep(api.selectedProduct)" [showButtons]="true" buttonLayout="horizontal" spinnerMode="horizontal" [min]="0" inputStyleClass="w-3rem text-center py-2 px-1 border-transparent surface-800 text-300" [(ngModel)]="api.selectedProduct.quantity" 
								class="border-1 surface-border border-round" decrementButtonClass="p-button-text py-1 px-1" incrementButtonClass="p-button-text py-1 px-1" incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus"></p-inputNumber>
		</div>
		<div class="text-4xl py-4">Ou choisissez l'une des offres suivantes</div>
		<div class="surface-card shadow-2 border-round p-2">
			<div class="grid" *ngIf="api.selectedProduct">
				<ng-container *ngFor="let o of api.offers">
					<div class="col-12 md:col p-3 flex align-items-center md:justify-content-center md:border-right-1 border-bottom-1 lg:border-bottom-none surface-border cursor-pointer" (click)="offerChoosed = o" *ngIf="api.selectedProduct.authorizedOffers && api.selectedProduct.authorizedOffers.indexOf(o.id_offer) > -1">
						<div class="flex align-items-center mr-3">
							<p-radioButton name="offerChoosed" [value]="o" [(ngModel)]="offerChoosed"></p-radioButton>
						</div>
						<div>
							<span class="text-900 text-xl font-medium">{{o.name_offer}}</span>
							<p class="text-base text-500 font-medium mt-2 mb-0">{{evalReturn(o.description)}}</p>
						</div>
					</div>
				</ng-container>
			</div>
		</div>
	</div>
	<ng-template pTemplate="footer">
		<button pButton pRipple (click)="api.dialogOffers = false;" label="Annuler" class="p-button-outlined p-button-danger"></button>
		<button [disabled]="!offerChoosed && (api.selectedProduct.quantity === undefined || api.selectedProduct.quantity < 1)" pButton pRipple (click)="api.dialogOffers = false; chooseOffer()" label="Valider" class=""></button>
	</ng-template>
</p-dialog>
